



























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() isCopy!: boolean;

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            if (this.isCopy === true) {
              const res = await this.$store.dispatch("articleCate/add", {
                ...values,
              });

              if (res && res.Message && res.Message === "success") {
                this.$message.success("添加成功");

                this.handleCancel();
              } else {
                this.$message.error("添加失败");
              }
            } else {
              const res = await this.$store.dispatch("articleCate/edit", {
                id: this.editId,
                ...values,
              });
              if (res && res.Message && res.Message === "success") {
                this.$message.success("修改成功");

                this.handleCancel();
              } else {
                this.$message.error("修改失败");
              }
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("articleCate/detail", {
      id: this.editId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
